import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    credentials: {
      adress: "",
      city: "",
      currentBarcode: "",
      showAdvice: false,
      country: "",
      customerId: "",
      email: "",
      endReturnDate: "",
      firstName: "",
      id: "",
      lastName: "",
      postalCode: "",
      preposition: "",
      role: 0,
      roleNames: [],
      schoolId: "",
      schoolName: "",
      schoolNumber: "",
      softEmail: "",
      startReturnDate: "",
      userName: "",
    },
  },
  reducers: {
    setUserCredentials: (state, action) => {
      state.credentials = { ...state.credentials, ...action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserCredentials } = userSlice.actions;

export default userSlice.reducer;
